import { v4 as uuid } from 'uuid';
export class ProductionUuidGateway {
    nextId() {
        return Promise.resolve(uuid());
    }
}
